import styled from 'styled-components';

export const StyledChart = styled.div`
  height: 30vh;
  width: 100%;
`;